import { gql } from '@apollo/client'

export const CHECK_USER_OLD_PASSWORD = gql`
  mutation CheckOldPassword($inputData: CheckOldPasswordInput!) {
    checkOldPassword(inputData: $inputData)
  }
`
